import { AccountType } from "operations";

export const AccountTypeMap: Record<AccountType, number> = {
  [AccountType.Admin]: 1,
  [AccountType.Brand]: 2,
  [AccountType.Retailer]: 3,
};
